export const FOOTER_SEO_CONTENT_MEDICAL_FUNDRAISING = {
  mainTitle: 'How Medical Crowdfunding Can Help You Raise Funds for Medical Treatment?',
  sections: [
    {
      id: 1,
      heading: 'Need Financial Help for Medical Treatment? Start a Fundraiser on Ketto Today',
      subHeading: '',
      desc: `Raise funds for medical treatment with a community that cares, so you can stop worrying about bank loans and focus entirely on your loved one’s journey to recovery. In 2026, hospital bills in India are rising faster than ever, often growing at 14% annually. Medical emergencies come unannounced, and even the most careful savings can disappear in days. When you need financial help for medical treatment, the last thing you should be doing is running from person to person for a loan.
            <br/>
            <div class='mt-2'>At Ketto, we’ve created a safe, trusted platform that helps bridge the gap between a medical crisis and the quality medical care your loved one deserves. Whether it is an unexpected ICU stay that costs ₹15,000–₹50,000 per day or a long-term cancer battle requiring ₹5–₹25 lakh, you don’t have to carry that burden alone. By starting a medical fundraising campaign, you give friends, family, and kind strangers a way to stand by you during your difficult times.</div>`,
      children: null
    },
    {
      id: 2,
      heading: '',
      subHeading: 'What is Medical Crowdfunding and How Does It Work?',
      desc: `What is medical crowdfunding? In the simplest terms, it is a way to collect small donations from a large group of people online to fund someone’s medical treatment. Instead of a single high-interest loan, you use a medical treatment crowdfunding platform to turn your struggle into a shared story of hope.`,
      children: [
        {
          list: [
            {
              list: [
                {
                  id: 1,
                  val: `<strong>How online fundraising works</strong>: You set up a page on a medical fundraising website like Ketto, share the patient's story, medical documents, and invite others to contribute.`,
                },
                {
                id: 2,
                  val: `<strong>Community-Based Donations</strong>: People who see your appeal, whether they know you or not, can offer a donation for medical treatment.`
                },
                {
                  id: 3,
                  val: `<strong>Digital Payments</strong>: Today, the best way to raise money for medical expenses is through the phone. Donors can send money instantly via UPI, net banking, or debit cards, which is key when you need funding for medical bills immediately.`
                },
              ],
            }
          ]
        },
      ]
    },
    {
      id: 3,
      heading: '',
      subHeading: 'Why Medical Fundraising is Important in India',
      desc: `The need for financial help for medical treatment in India is a reality for millions because healthcare costs often move much faster than our insurance policies.`,
      children: [
        {
          list: [
            {
              list: [
                {
                  id: 1,
                  val: "<strong>Rising Medical Inflation:</strong> Hospital bills in India are growing at nearly 14% every year, meaning that even a well-planned savings account can be wiped out in a single week. This makes it incredibly difficult for middle-class families to keep up with the soaring costs of private hospital treatments."
                },
                {
                  id: 2,
                  val: "<strong>The Insurance Gap:</strong> Most health insurance policies in India only cover the basics, leaving a massive \"hidden cost\" for surgeries and specialised care. For a major operation, you are often left to pay the remainder \"out of pocket,\" which can run into lakhs of rupees."
                },
                {
                  id: 3,
                  val: "<strong>Emergency Surgeries:</strong> When an accident happens, every second counts. When you need money for medical treatment or an emergency surgery, you don’t have the luxury of time to wait for bank approvals or loan paperwork while your loved one is in the ER."
                },
                {
                  id: 4,
                  val: "<strong>Rural vs Urban Divide:</strong> Families from smaller towns often have to travel thousands of miles to big cities for specialised care, adding the high cost of travel and lodging to an already high hospital bill. Medical crowdfunding helps take some of the burden off their shoulders by connecting them with donors who understand their struggle and are ready to help pay for the patient’s medical treatment."
                },
                {
                  id: 5,
                  val: "<strong>The Reality:</strong> Stats show that over 55 million Indians fall into poverty every year because of \"out-of-pocket\" medical spending. This is why seeking financial help for medical treatment in India has become a critical necessity for families who want their loved ones to receive the best medical care without draining their savings and resources."
                }

              ],
            }
          ]
        },
      ]
    },
    {
      id: 4,
      heading: '',
      subHeading: 'When You’re Crowdfunding for Medical Treatment, What Medical Expenses Can Be Covered?',
      desc: `You can fundraise for medical expenses for almost any treatment that stands between your loved one and their recovery. Today, families are using fundraising for medical treatment to cover everything from sudden surgeries to long-term hospital stays, including:`,
      children: [
        {
          list: [{
            list: [
              {
                id: 1,
                val: "<strong>Cancer Treatment:</strong> A full course of chemotherapy, radiation, and surgery can cost anywhere from ₹5 lakh to ₹25 lakh. By using medical crowdfunding, families can cover these recurring costs without using up their life savings."
              },
              {
                id: 2,
                val: "<strong>Organ Transplant:</strong> Procedures such as liver, kidney, or heart transplants, including the intensive post-operative care and lifelong immunosuppressants, range from ₹20 lakh to ₹35 lakh. Medical crowdfunding for transplant costs is often the only way for families to secure the massive hospital deposits required before the surgery can be scheduled."
              },
              {
                id: 3,
                val: "<strong>Heart Surgery:</strong> Complex cardiac procedures like bypass surgery or valve replacements generally cost ₹3 lakh to ₹8 lakh. For those who need funds for medical treatment to cover these high surgical costs, starting a fundraiser is a fast way to ensure the surgery happens on time without having to sell family assets or take high-interest loans."
              },
              {
                id: 4,
                val: "<strong>Accident & Trauma Care:</strong> Emergency brain or spinal surgeries following an accident can lead to bills of ₹5 lakh to ₹12 lakh. When you need money for medical treatment instantly, an online appeal is the fastest way to mobilise support."
              },
              {
                id: 5,
                val: "<strong>ICU Expenses:</strong> A stay in the ICU can burn through ₹15,000 to ₹50,000 per day, depending on the hospital. When you’re crowdfunding for medical bills, it helps cover these daily costs so you can keep your loved one on life support for as long as needed."
              },
              {
                id: 6,
                val: "<strong>Newborn NICU Care:</strong> Critical care for premature babies in the NICU often costs ₹20,000 to ₹40,000 daily, totaling ₹10 lakh+ for long stays. Medical fundraising isn't just about the money; it helps ensure that the hospital never has to ask a parent to leave because they can't pay the next deposit, giving that baby the time they simply need to grow stronger."
              },
              {
                id: 7,
                val: "<strong>Dialysis & Kidney Care:</strong> Long-term dialysis can cost ₹20,000 to ₹40,000 per month. Starting a fundraiser for medical expenses helps manage these high costs that insurance often stops covering after a while."
              },
              {
                id: 8,
                val: "<strong>Rare Diseases:</strong> When a child is diagnosed with SMA, you aren’t just fighting a disease; you’re facing a ₹16 crore to ₹17.5 crore price tag for a single dose of medicine. No family in India is expected to have that kind of money sitting in a bank account, and the weight of that reality is overwhelming. Using a medical treatment crowdfunding platform is the only way many families actually reach that goal: by letting lakhs of people online contribute small amounts to cover a cost that no one should have to carry alone."
              },
              {
                id: 9,
                val: "<strong>Post-Surgery Rehabilitation:</strong> Home nursing and physiotherapy can add ₹50,000 to ₹1 lakh to your total bill. Raising funds for medical expenses ensures that the recovery process is just as supported as the surgery itself."
              }
            ]
          }
          ]
        }
      ]
    },
    {
      id: 5,
      heading: '',
      subHeading: 'How to Start Your Medical Fundraiser on Ketto',
      desc: `When you’re in the middle of a medical emergency, you don’t have time for complicated forms. Starting a medical fundraiser on Ketto takes about three minutes, so you can focus on being there for your loved one.<br/> <div class='desc mt-4'>Here is how to raise funds for medical treatment in five simple steps:</div>`,
      children: [
        {
          list:
          [
            {
            bullet:true,
            list : [
              {
                id: 1,
                val: "<strong>Sign Up for Free:</strong> By heading to the Ketto website, you can create an account in under two minutes to begin your online medical fundraising journey."
              },
              {
                id: 2,
                val: "<strong>Share the Story:</strong> Write a few lines about what happened. Adding a photo or a short video of the patient is often the best way to raise money for medical expenses, as it helps people connect with your family or patient."
              },
              {
                id: 3,
                val: "<strong>Upload Basic Documents:</strong> To ensure it is a trusted medical fundraiser, simply upload the hospital’s cost estimate or a medical report for verification."
              },
              {
                id: 4,
                val: "<strong>Set Your Goal:</strong> Enter the total medical treatment funding you need to include the surgery, hospital stay, and recovery costs."
              },
              {
                id: 5,
                val: "<strong>Share on WhatsApp:</strong> This is the most vital step. Use the \"Share\" button to send your fundraiser link to friends, family, and groups to start fundraising for medical treatment immediately."
              }
            ]
              },
              {
                bullet: false,
                desc: "<strong>Why families choose this path:</strong>",
                list: [
                  {
                    id: 1,
                    val: "<strong>Quick Approval:</strong> Most fundraisers are verified and go live within 24 hours because we know every second counts."
                  },
                  {
                    id: 2,
                    val: "<strong>Zero Platform Fee:</strong> Ketto offers a <a href=\"https://www.ketto.org/support/plans-and-pricing.php\" target=\"_blank\">0% platform fee*</a> model, so the maximum amount possible goes directly toward treatment."
                  },
                  {
                    id: 3,
                    val: "<strong>UPI-Enabled Donations:</strong> Donors can give instantly via GPay, PhonePe, or Paytm, which is critical when you need money for medical treatment for an emergency."
                  },
                  {
                    id: 4,
                    val: "<strong>Direct Transfers:</strong> You don't have to wait for the medical fundraiser to finish; you can withdraw the funds directly to the hospital or your bank account as they come in."
                  }
                ]
            }
        ]
        }
      ]
    },
    {
      id: 6,
      heading: '',
      subHeading: 'Why Choose Ketto for Medical Crowdfunding?',
      desc: `If you’re looking for the best medical crowdfunding site,  reach out to Ketto, because we prioritise speed and transparency.`,
      children: [
        {
          list: [
            {
              list: [
                {
                  id: 1,
                  val: "<strong>Secure Payment Gateway:</strong> Every donation for medical help is safe and encrypted."
                },
                {
                  id: 2,
                  val: "<strong>80G Tax Benefits:</strong> We provide tax certificates, which help you get more support from donors."
                },
                {
                  id: 3,
                  val: "<strong>Real-Time Tracking:</strong> See your fund for medical treatment grow every hour."
                },
                {
                  id: 4,
                  val: "<strong>Fast Withdrawal:</strong> We understand that emergencies don't wait."
                },
                {
                  id: 5,
                  val: "<strong>Dedicated Support:</strong> Our team provides medical crowdfunding tips to help you reach your goal."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 7,
      heading: '',
      subHeading: 'Tips to Raise More Funds for Medical Treatment',
      desc: `Creating a page is just the start. To make yours a successful medical fundraising story, focus on building a real connection with your community using these medical fundraising ideas:`,
      children: [
        {
          list: [
            {
              list: [
                {
                  id: 1,
                  val: "<strong>Tell the Real Story:</strong> Don’t worry about making it sound professional. Just describe the patient’s life before they got sick, their favorite things, and what this recovery would mean for their future. When donors feel like they know the person, they are much more likely to support you as you’re fundraising for medical treatment."
                },
                {
                  id: 2,
                  val: "<strong>Use ‘Real’ Photos:</strong> You don't need a professional camera. A clear photo of the patient, whether it’s a happy memory or a photo from the hospital, helps people understand the urgency. These visuals are often the best way to raise money for medical expenses because they show the human face behind the bill."
                },
                {
                  id: 3,
                  val: "<strong>Keep Your Supporters Close:</strong> Short regular updates go a long way. Whether you’re sharing updates about the patient slowly getting better or a thank-you note after a successful surgery, sharing the journey helps your donors feel like they are part of the recovery, not just a transaction."
                },
                {
                  id: 4,
                  val: "<strong>The WhatsApp Advantage:</strong> In India, your biggest support comes from the people you already know. Sending your link to WhatsApp groups: family, office, or school alumni, is the fastest way to get your story moving. Personal messages in these groups are incredibly effective when you need money for medical treatment quickly."
                },
                {
                  id: 5,
                  val: "<strong>Reach Out to Your Community:</strong> Don't be afraid to ask for help from your local housing society, sports club, or even local influencers. Often, people want to help but just don't know how; giving them a link to your online medical fundraising page gives them a concrete way to support you."
                }
              ]
            }
          ]
        }
      ]
    },
    {
      id: 8,
      heading: '',
      subHeading: 'Frequently Asked Questions (FAQs)',
      children: [
        {
          id: 1,
          heading: "Q. How to get funding for medical treatment?",
          desc: "A. The best way to raise money for medical expenses is to start a medical fundraiser on Ketto and share the link on your WhatsApp immediately.",
          list: null
        },
        {
          id: 2,
          heading: "Q. Can you raise money for medical expenses?",
          desc: "A. Yes, anyone in India can raise funds for medical bills by creating a campaign on a medical fundraising website like ours.",
          list: null
        },
        {
          id: 3,
          heading: "Q. Is medical crowdfunding legal in India?",
          desc: "A. Yes, medical crowdfunding in India is 100% legal and follows all financial regulations.",
          list: null
        },
        {
          id: 4,
          heading: "Q. How do donors know it’s genuine?",
          desc: "A. Ketto verifies every fundraiser using hospital documents to ensure it is a medical treatment funding request for a real patient. You can <a href='https://www.ketto.org/blog/are-campaigns-in-ketto-genuine' target=\"_blank\">click here</a> to know more.",
          list: null
        },
        {
          id: 5,
          heading: "Q. How to raise money for medical bills?",
          desc: "A. If you want to raise funds for medical treatment, be honest, share your medical reports, and use an online medical fundraising platform to reach people who want to help.",
          list: null
        },
        {
          id: 6,
          heading: "Q. How long does it take to raise funds?",
          desc: "A. Most families see their first donation within minutes of sharing their link on WhatsApp. While a full medical treatment funding goal might take a few days or weeks to reach, the platform allows you to withdraw funds as they come in, which is vital when you need money for medical treatment for an urgent surgery.",
          list: null
        },
        {
          id: 7,
          heading: "Q. Are donations tax-deductible?",
          desc: "A. Yes, most donations made toward a trusted medical fundraiser are eligible for tax benefits under Section 80G of the Income Tax Act. Donors receive an 80G certificate instantly, which encourages more people to contribute larger amounts to your online medical fundraising page.",
          list: null
        },
        {
          id: 8,
          heading: "Q. Is there any platform fee on Ketto?",
          desc: "A. To ensure the maximum amount of help reaches the patient, Ketto offers a 0% platform fee. This means that every rupee donated by your friends and family goes toward the hospital bills and recovery, making it the best way to raise money for medical expenses without losing a portion to service charges.",
          list: null
        },
        {
          id: 9,
          heading: "Q. Can I raise funds for someone else?",
          desc: "A. Absolutely. Many people start fundraising for medical treatment for their parents, friends, employees, or even neighbours. As long as you have the patient’s consent and the necessary hospital documents to verify the case, you can start raising funds for medical expenses on their behalf.",
          list: null
        }
      ]
    },
    {
      id: 9,
      subHeading: "Conclusion",
      desc:`Don't let the pressure of hospital deposits lead you toward high-interest loans or selling your assets. Medical crowdfunding offers a way to get the funds you need without the burden of repayment. It takes as little as 5 minutes to <a href=\"https://www.ketto.org/new/crowdfunding?saf_source=footer_seo_medical\" target=\"_blank\">set up your online medical fundraising page </a> on <strong>ketto</strong> and start receiving help from our wonderful community of donors without delay.`,
      children:null
    }
  ],
  searches: {
    data: `<a href="https://www.ketto.org/blog/twenty-five-quick-fundraising-ideas">25 Creative Fundraising Ideas</a> |
        <a href="https://www.ketto.org/blog/zolgensma-price-in-india">Zolgensma: Price in India & Availability</a> |
        <a href="https://www.ketto.org/campaign/crowdfunding-for-education.php">Education Crowdfunding </a> |
        <a href="https://www.ketto.org/how_it_works/fundraising-ideas-for-ngos.php">NGO Fundraising</a> |
        <a href="https://www.ketto.org/blog/social-impact-plan-from-ketto-is-taking-fundraising-to-the-next-level">  Monthly Contribution Plan (SIP)</a> |
        <a href="https://www.ketto.org/blog/how-to-start-crowdfunding-for-animal-rescue">Crowdfunding for Animal Rescue</a> |
        <a href="https://www.ketto.org/blog/how-can-i-raise-money-for-charity">Raise Money for Charity</a> |
        <a href="https://www.ketto.org/blog/five-quick-fundraising-ideas"> Fundraising Ideas </a> |
        <a href="https://www.ketto.org/blog/what-are-the-types-of-crowdfunding-in-india">Types of Crowdfunding</a> |
        <a href="https://www.ketto.org/blog/crowdfunding-for-teachers-how-to-raise-money-for-your-classroom"> Crowdfunding for Teachers</a>`
  }

};
